import { render } from "./PositionHeld.vue?vue&type=template&id=773743fd"
import script from "./PositionHeld.vue?vue&type=script&lang=js"
export * from "./PositionHeld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__